import styled from 'styled-components';
import { BATTLESHIP, GYPSUM } from 'HubStyleTokens/colors';
import { device } from '../../constants/StyledComponentConstants';
export const LEARNING_PAGE_SIDEBAR_WIDTH = 320;
const LearningPageSidebar = styled.div.withConfig({
  displayName: "LearningPageSidebar",
  componentId: "sc-18l9km6-0"
})(["background-color:", ";border-right:1px solid ", ";max-width:", "px;min-width:", "px;height:calc(100vh - ", ");position:sticky;top:", ";overflow-y:auto;@media screen and ", "{display:none;}"], GYPSUM, BATTLESHIP, LEARNING_PAGE_SIDEBAR_WIDTH, LEARNING_PAGE_SIDEBAR_WIDTH, props => props.withSubNav ? '126px' : '86px', props => props.withSubNav ? '126px' : '86px', device.tablet);
export default LearningPageSidebar;